class MBWG {
    constructor() {
        this.btn = $('.mbwg');
        this.table = $('.table-mbwg');
        var that = this;

        $(this.btn).on('click tap', function (e) {
            that.initmbwg();
            e.preventDefault();
        });

    }

    initmbwg() {
        let that = this;
        var $rows = that.table.find('tr').sort(function (a, b) {
            // Retrieve the data-pos attribute values
            var posA = $(a).data('pos');
            var posB = $(b).data('pos');

            // Compare the data-pos values for sorting
            return posA - posB;
        });

        $rows.each(function (index) {
            that.table.append(this); // Fügt die sortierten Zeilen wieder in die Tabelle ein
            $(this).find('td:first').text(index); // Aktualisiert den ersten td mit der Zeilennummer
            if ($(this).data('is-club')) {
                // Holen Sie sich die Zahl aus der Spalte "Spiele"
                var spiele = $(this).find('td[data-table="spiele"]').text();
                // Berechnen Sie die Punkte
                var punkte = parseInt(spiele) * 3;
                var tore = parseInt(spiele) * 5;
                // Setzen Sie das Ergebnis in die Spalte "Punkte"
                $(this).find('td[data-table="punkte"]').text(punkte);
                $(this).find('td[data-table="siege"]').text(spiele);
                $(this).find('td[data-table="unents"]').text('0');
                $(this).find('td[data-table="nieder"]').text('0');
                $(this).find('td[data-table="tore"]').text(tore + ' : 0');
            }
        });

    }
}
